export default __webpack_public_path__ + "static/media/fastapi.4dbff8f1.svg";